import * as React from "react";

function CoinIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M410.4 245.9c-10.7 8-24.6 14.2-39.7 18.9-30.4 9.6-71 14.3-114.7 14.3s-84.3-4.7-114.7-14.3c-15.1-4.7-29-10.9-39.7-18.9C91.33 238.3 80 225.7 80 208s11.33-30.3 21.6-37.9c10.7-8 24.6-14.2 39.7-18.9 30.4-9.6 71-15.2 114.7-15.2s84.3 5.6 114.7 15.2c15.1 4.7 29 10.9 39.7 18.9 10.3 7.6 21.6 20.2 21.6 37.9s-11.3 30.3-21.6 37.9zm-254.7-49c-12.6 3.8-19.8 7.7-24.6 11.1 4.8 3.4 12 7.3 24.6 11.1 24.6 7.7 60.1 12.9 100.3 12.9 40.2 0 75.7-5.2 100.3-12.9 11.7-3.8 19.8-7.7 24.6-11.1-4.8-3.4-12.9-7.3-24.6-11.1-24.6-7.7-60.1-12.9-100.3-12.9-40.2 0-75.7 5.2-100.3 12.9zM512 208v112c0 70.7-114.6 128-256 128S0 390.7 0 320V208C0 128.5 114.6 64 256 64s256 64.5 256 144zM98.51 267.1C136.4 289.3 191.1 304 256 304c64 0 119.6-14.7 157.5-36.9 39.4-21.3 50.5-44.4 50.5-59.1 0-14.7-11.1-37.8-50.5-60-37.9-21.3-93.5-36-157.5-36-64.9 0-119.6 14.7-157.49 36C59.11 170.2 48 193.3 48 208c0 14.7 11.11 37.8 50.51 59.1zM216 398.3a471.705 471.705 0 0 0 80 0v-48c-13.9 1.1-26.4 1.7-40 1.7-13.6 0-27-.6-40-1.7v48zm-32-52.1c-22.8-3.7-44.3-10.1-64-16.2v47.7c18.7 7 40.3 12.7 64 16.6v-48.1zM48 320c0 6.8 6.21 24.2 40 43.1v-46.4c-14.96-7.4-28.4-15.7-40-25.6V320zm344 57.7V330c-19.7 6.1-41.2 12.5-64 16.2v48.1c23.7-3.9 45.3-9.6 64-16.6zm32-14.6c33.8-18.9 40-36.3 40-43.1v-28.9c-11.6 9.9-25.9 18.2-40 25.6v46.4zm-39.3-151.9c0 .1.1.2.1.2l-.1-.2zm.1-6.6s-.1.1-.1.2l.1-.2zm-257.5.2c0-.1-.1-.2-.1-.2l.1.2zm-.1 6.6s.1-.1.1-.2z"
  }));
}

const ForwardRef = React.forwardRef(CoinIcon);
export default ForwardRef;